// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0TOLX","informacoes":"styles_informacoes__NSvel","endereco":"styles_endereco__VbxZ1"};